// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Globe as RawGlobe } from "lucide-react";
export const Globe = /* @__PURE__ */ createIcon(RawGlobe, "Globe", 2);
